// cmsmodules imagesmulticolumn  => in phone wird ein slider angezeigt wenn die option gesetzt ist
import Splide from '@splidejs/splide';

export class ImagesMultiColumn {

    constructor(content: Element = document.documentElement) {
        const mobileSliders = content.querySelectorAll('.cms-module-root .sliderMobile');

        if (mobileSliders.length > 0) {
            mobileSliders.forEach((mobileSlider) => {
                this.initializeSlider(mobileSlider as HTMLElement);
            });
        }
    }


    private initializeSlider(mobileSlider: HTMLElement): void {
        const sliderMobile = mobileSlider.querySelector('.ul-slider.splide');

        if (!sliderMobile) {
            return;
        }

        const sliderMobileId = sliderMobile.getAttribute('id');
        const type = mobileSlider.getAttribute('data-slider-type');
        const rewind = mobileSlider.getAttribute('data-slider-rewind');
        const rewindBoolean = (rewind === 'true');

        const isDialog = sliderMobile.closest('sl-dialog');
        const sliderID = isDialog
            ? `sl-dialog #${sliderMobileId}.splide`
            : `#${sliderMobileId}.splide`;

        // Wenn 'type' oder 'rewind' nicht gesetzt sind, wird die aktuelle Iteration uebersprungen.
        if (!type || !rewind) {
            return;
        }
        document.querySelectorAll(sliderID).forEach(slider => {

            if (!slider.classList.contains('is-initialized')) {
                slider.classList.add('is-initialized');
                // Initialisiere den Splide-Slider mit den festgelegten Optionen.
                new Splide(slider as HTMLElement, {
                    type: type,
                    speed: 500,
                    perPage: 2,
                    perMove: 1,
                    focus: 'center',
                    gap: 0,
                    rewind: rewindBoolean,
                    fixedWidth: 280,
                    start: 1,
                    pagination: false,
                    arrows: false,
                }).on('mounted', () => {
                    //Eye Able Report: ARIA-Wert oder -Attribut nicht unterstuetzt
                    slider.querySelectorAll('.splide__slide[role="group"],.splide__slide[role="button"]').forEach(el => {
                        el.removeAttribute('role');
                    });
                }).mount();
            }
        });
    }
}


